import type {
  ApiFetchBlogPostsParams,
  ApiFetchBlogPostsPort,
} from '~/handlers/ports/api-fetch-blog-posts.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchBlogPostsAdapter
  implements ApiFetchBlogPostsPort
{
  async handle(
    params: ApiFetchBlogPostsParams = {},
  ): Promise<BlogCore.Category[]> {
    const url = new URL(`${getApostatudoApiUrl()}/blog/posts`);

    if (params.category) url.searchParams.set('category', params.category);
    if (params.state) url.searchParams.set('state', params.state);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      console.warn(
        `[ApiFetchBlogPosts] API returned ${response.status}: ${response.statusText}`,
      );

      return [];
    }

    const json = await response.json();
    const data = Array.isArray(json) ? json : json?.data;

    if (!Array.isArray(data)) {
      console.warn('[ApiFetchBlogPosts] API response is not an array:', json);

      return [];
    }

    return data as BlogCore.Category[];
  }
}
